import type {LocalesExtensionAPI} from '@wix/document-manager-extensions'
import type {PS} from '@wix/document-services-types'

const list = (ps: PS) => (ps.extensionAPI as LocalesExtensionAPI).locales.list()

const isMultilingualEnabled = (ps: PS): boolean =>
    (ps.extensionAPI as LocalesExtensionAPI).locales.isMultilingualEnabled()

export const locales = {
    list,
    isMultilingualEnabled
}
